import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PasswordResetCodeSerializer = {
  email: string;
  email_sent: boolean;
  message: string;
};

export type PostPasswordResetCodePayloadType = (
  Pick<PasswordResetCodeSerializer, 'email'>
);
export type PostPasswordResetCodeResponseType = (
  Pick<PasswordResetCodeSerializer, 'email_sent' | 'message'>
);

export const apiRequestPasswordResetCode = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostPasswordResetCodePayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.passwordResetCode(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
